/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 *
 * Carcasa Square de módulos operativos (Catálogo / Stock / Ventas…):
 * mint canvas + columna con gap entre PaperSheets.
 * El body (lista / tabla) lo pone el caller — a menudo FlatList con ListHeader.
 */
import React from 'react';
import { StyleSheet, View, type StyleProp, type ViewStyle } from 'react-native';
import { spacing, ticketColors } from '../theme/public-api';
import { ShellContentFrame } from '../layout/ShellContentFrame';

export type TicketModuleScreenProps = {
  children: React.ReactNode;
  /** Sheet de título + tools (search / Nuevo / …). */
  header?: React.ReactNode;
  /** KPI strip (suele ir en PaperSheet o TicketKpiStrip soft). */
  kpis?: React.ReactNode;
  /** Alerta / lookup / notice opcional. */
  notice?: React.ReactNode;
  /** Footer sticky (paginación). */
  footer?: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  /** Gap entre bloques paper. Default spacing.sm. */
  gap?: number;
  testID?: string;
};

export function TicketModuleScreen({
  children,
  header,
  kpis,
  notice,
  footer,
  style,
  gap = spacing.sm,
  testID,
}: TicketModuleScreenProps) {
  const hasChromeSlots = Boolean(header || kpis || notice);

  return (
    <ShellContentFrame style={style} testID={testID}>
      <View style={[styles.column, { gap }]}>
        {hasChromeSlots ? (
          <View style={[styles.slots, { gap }]}>
            {header ?? null}
            {kpis ?? null}
            {notice ?? null}
          </View>
        ) : null}
        <View style={styles.body}>{children}</View>
      </View>
      {footer ?? null}
    </ShellContentFrame>
  );
}

const styles = StyleSheet.create({
  column: {
    flex: 1,
    minHeight: 0,
    backgroundColor: ticketColors.bg,
  },
  slots: {
    flexShrink: 0,
    paddingHorizontal: spacing.md,
    paddingTop: spacing.sm,
  },
  body: {
    flex: 1,
    minHeight: 0,
  },
});
